import { DemoSettings } from 'Types';

export function mapDemoToSettings<T>(demo: DemoSettings | null): T | null {
  return !demo
    ? null
    : (demo.fields.reduce(
        (acc, field) => ({
          ...acc,
          [field.name]: field.value,
        }),
        {}
      ) as T);
}
